import { AfterLoadEventHandler, CreateOptionsParams, ISpecializedCombo, useCombo } from "@hooks/useCombo";
import { MenuItem } from "@material-ui/core";
import { useFaturaService } from "@services/FaturaService";
import { useThemeColor } from "@themes/Colors";
import { KeyOfEnum } from "@utils/TypeHelpers";
import React from "react";

export enum EnumFaturaStatus {
    None = "0",
    Aberta = 1,
    Paga = 2,
    Cancelada = 3,
    Vencida = 4
}
export default interface IFaturaStatus {
    faturaStatusId: number,
    nome: string,
    ativo: string,
}

export type IComboFaturaStatus = ISpecializedCombo<IFaturaStatus>;

export function useFaturaStatusCombo (initialValue?: EnumFaturaStatus) : IComboFaturaStatus {
    const combo = useCombo<IFaturaStatus>({
        value: initialValue
    });

    const faturaService = useFaturaService();

    const createOptions = React.useCallback((params?: CreateOptionsParams) => {
        return combo.set.map((faturaStatus, index) => {
            return <MenuItem key={index} value={faturaStatus.faturaStatusId}>{params?.prefix}{faturaStatus.nome}{params?.sufix}</MenuItem>
        });
    }, [combo.set]);

    const loadOptions = React.useCallback((afterLoad?: AfterLoadEventHandler<IFaturaStatus>) => {
        combo.load(faturaService.listarStatusAtivos, afterLoad)
    }, [combo, faturaService.listarStatusAtivos]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions
    }), [combo, createOptions, loadOptions]);
}

export function useFaturaStatusColor () {
    const themeColor = useThemeColor();

    const map : KeyOfEnum<EnumFaturaStatus, string> = React.useMemo(() => ({
        [EnumFaturaStatus.None]: "",
        [EnumFaturaStatus.Aberta]: themeColor.status.laranja,
        [EnumFaturaStatus.Paga]: themeColor.status.verde,
        [EnumFaturaStatus.Cancelada]: themeColor.status.cinza,
        [EnumFaturaStatus.Vencida]: themeColor.status.vermelho
    }), [themeColor.status.cinza, themeColor.status.laranja, themeColor.status.verde, themeColor.status.vermelho]);

    return React.useMemo(() => map, [map]);
}